import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'style/common.css.ts';
import App from './App';
import reportWebVitals from './reportWebVitals';


const rootElement = document.getElementById('root')!; // 느낌표로 “절대 null이 아님”을 단언
const root = ReactDOM.createRoot(rootElement);
const isDev = process.env.NODE_ENV === 'development';
root.render(
  isDev ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
